const e=e=>e;var r=(()=>{let r=e;return{configure(e){r=e},generate:e=>r(e),reset(){r=e}}})();export{r as default};
//# sourceMappingURL=ClassNameGenerator.js.map
